import styled from "styled-components";
import { LinearProgress } from "@mui/material";

import { StyledFilters } from "../../molecules/FilterOptions/styled";

export const StyledPaginatedListPage = styled.div`
    width: 100%;

    .filters {
        margin-bottom: 0;
        border-bottom: 0;
    }

    ${StyledFilters} {
        margin-bottom: 0;
    }
`;

export const StyledPaginatedProgressBar = styled(LinearProgress)<{ $isLoading: boolean }>`
    display: none;
    height: 2px;
    margin-bottom: 9px;
    background-color: var(--color-grey-600);

    .barColorPrimary {
        background-color: var(--color-grey-700);
    }

    ${(props) =>
        props.$isLoading &&
        `
            display: block;
  `}
`;

export const StyledPaginatedSeparator = styled.hr<{ $isLoading: boolean }>`
    margin-top: 0;
    margin-bottom: 9px;
    border-top: 2px solid var(--color-grey-600);
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    ${(props) =>
        props.$isLoading &&
        `
            display: none;
  `}
`;

export const StyledPaginatedList = styled.div`
    margin: 2rem 0;
`;
